import { render, staticRenderFns } from "./ProductsTypeManage.vue?vue&type=template&id=9173268e&scoped=true&"
import script from "./ProductsTypeManage.vue?vue&type=script&lang=js&"
export * from "./ProductsTypeManage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTypeManage.vue?vue&type=style&index=0&id=9173268e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9173268e",
  null
  
)

export default component.exports